import React from "react";
import { Row, Col, Tooltip, Tag } from "antd";
import { PlusOutlined, DeleteOutlined, StopOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { InputItem, InputNumberItem, ButtonItem } from "../../../../Components/Items";

const EditorMotivosEtapa = ({ motivos, onChange, soloLectura }) => {
  const cambiar = (index, cambios) => onChange(motivos.map((m, i) => (i === index ? { ...m, ...cambios } : m)));
  const quitar = (index) => onChange(motivos.filter((_, i) => i !== index));
  const agregar = () =>
    onChange([...motivos, { nombre: "", orden: motivos.reduce((max, m) => Math.max(max, m.orden || 0), 0) + 1, estado: 1 }]);

  return (
    <>
      {motivos.length === 0 && <div style={{ color: "#999", fontSize: 12, marginBottom: 8 }}>Esta etapa no tiene motivos.</div>}
      {motivos.map((motivo, index) => (
        <Row key={motivo._id || `nuevo-${index}`} gutter={8} align="middle" style={{ marginBottom: 8 }}>
          <Col span={3}>
            <InputNumberItem placeholder="Orden" min={0} disabled={soloLectura} value={motivo.orden} onChange={(orden) => cambiar(index, { orden })} />
          </Col>
          <Col span={15}>
            <InputItem
              placeholder="Nombre del motivo (ej. Grumo de pintura)"
              disabled={soloLectura}
              value={motivo.nombre}
              onChange={(e) => cambiar(index, { nombre: e.target.value })}
            />
          </Col>
          <Col span={3}>{motivo.estado === 2 && <Tag color="red">Inactivo</Tag>}</Col>
          {!soloLectura && (
            <Col span={3} style={{ textAlign: "right" }}>
              {motivo.estado === 2 ? (
                <Tooltip title="Activar">
                  <ButtonItem type="default" size="small" lima icon={<CheckCircleOutlined />} onClick={() => cambiar(index, { estado: 1 })} />
                </Tooltip>
              ) : (
                <Tooltip title="Desactivar">
                  <ButtonItem type="default" size="small" naranja icon={<StopOutlined />} onClick={() => cambiar(index, { estado: 2 })} />
                </Tooltip>
              )}{" "}
              <Tooltip title="Quitar">
                <ButtonItem type="default" size="small" rojo icon={<DeleteOutlined />} onClick={() => quitar(index)} />
              </Tooltip>
            </Col>
          )}
        </Row>
      ))}
      {!soloLectura && (
        <ButtonItem icon={<PlusOutlined />} onClick={agregar} size="small">
          Agregar motivo
        </ButtonItem>
      )}
    </>
  );
};

export const motivosParaGuardar = (motivos) =>
  motivos.filter((m) => (m.nombre || "").trim()).map((m) => ({ _id: m._id, orden: m.orden, nombre: m.nombre, estado: m.estado }));

export default EditorMotivosEtapa;
